import React from 'react'

const FormNavbar = () => {
  return (
    <form className='form-navbar'>
      <input type="text" placeholder='Cari Nama Produk' />
      <span className='magnify-icon'><i className='fas fa-search'></i></span>
    </form>
  )
}

export default FormNavbar
